import { DtoBase } from '../../../types/Dtos/DtoBase'

export class CreateHistoryDto extends DtoBase {
  constructor(modelId: string, title: string, description: string) {
    super({ modelId, title, description })
  }
}
